module.exports = __webpack_public_path__ + "img/topic_create_icon.200104f4.svg";